module.exports = __webpack_public_path__ + "img/Logo_120x120.082d35cb.jpg";